import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class takeCowSynthesisPage extends cc.Component {

    @property({type:cc.Node,tooltip:"light节点"})
    lightNode:cc.Node = null;

    start(){
        let tween = cc.tween(this.lightNode).to(2.5,{angle:360});
        cc.tween(this.lightNode).repeatForever(tween).start();
    }

    onBtnComit(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
    }

}
